import { render, staticRenderFns } from "./UploadRecords.vue?vue&type=template&id=24f6f715"
import script from "./UploadRecords.vue?vue&type=script&lang=js"
export * from "./UploadRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports